import { emptyStatePrimaryButton } from "../ui/buttonStyles.js";

export function CreateListEmptyState({ title, hint, primaryAction, icon, c, A, dark }) {
  return (
    <div
      role="status"
      style={{
        flex: 1,
        minHeight: 280,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "32px 24px",
      }}
    >
      <div
        style={{
          width: 72,
          height: 72,
          borderRadius: 18,
          background: `${A}14`,
          border: `1px solid ${A}28`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: A,
          fontSize: icon ? undefined : 28,
          fontWeight: icon ? undefined : 800,
        }}
      >
        {icon ?? "+"}
      </div>
      <p style={{ margin: "16px 0 0", fontSize: 15, fontWeight: 700, color: c.text }}>{title}</p>
      <p style={{ marginTop: 10, fontSize: 13, color: c.sub, maxWidth: 360, lineHeight: 1.55 }}>{hint}</p>
      {primaryAction ? (
        <button type="button" onClick={primaryAction.onClick} style={emptyStatePrimaryButton(A, dark)}>
          {primaryAction.label}
        </button>
      ) : null}
    </div>
  );
}
